export const viewDetailsBundleAnalytics = (title = "", productInfo = {}) => {
  const eventInfo = {
    eventAction: `cart preview:view details:${title}`,
    eventName: `cart preview:view details:${title}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: `view details:${title}`,
    internalLinkPosition: "cart:bundle",
    internalLinkType: "cart:view details",
    internalLinkZoneName: "cart:preview",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(
    eventInfo,
    productInfo ? productInfo.productInfo : ""
  )
}

export const addAnlyticsForSDownloadSpec = (
  title = "",
  selectedFileList = [],
  techFils = [],
  mainTitle = ""
) => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const { productInfo } = page
  const techFilsLists = techFils.map(selectedObj => selectedObj.toLowerCase())
  const eventInfo = {
    eventAction: `pdp:${mainTitle}:${title}`,
    eventName: `pdp:${mainTitle}:${title}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "success",
    internalLinkName: `${title}|${selectedFileList.join(":").toLowerCase()}`,
    internalLinkPosition: "pdp:bundle",
    internalLinkType: `pdp:${mainTitle}:${title}`,
    internalLinkZoneName: `pdp:${mainTitle}`,
    internalLinkURL: techFilsLists.join(":"),
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const viewMoreBundleFeature = (url = "") => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const { productInfo } = page
  const eventInfo = {
    eventAction: "pdp:specs:view more",
    eventName: "pdp:specs:view more",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "view more",
    internalLinkPosition: "pdp:bundle",
    internalLinkType: "pdp:specs:view more",
    internalLinkZoneName: "pdp:specs",
    internalLinkURL: `${window.location.origin}${url}`,
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const accordianClickBundleFeature = (
  title = "",
  accordianState = ""
) => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const { productInfo } = page
  const eventInfo = {
    eventAction: `pdp:product details:filters ${accordianState}`,
    eventName: `pdp:product details:filters ${accordianState}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: accordianState,
    internalLinkPosition: "pdp:bundle",
    internalLinkType: `pdp:${title}`,
    internalLinkZoneName: "pdp:product details",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

const pushAnalyticsObjToDataLayer = (eventInfo = {}, productInfo = {}) => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const event = "cmp:click"
  window.adobeDataLayer.push({
    event,
    eventInfo,
    page,
    productInfo,
  })
}
